var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import translations from "../../translations/resources/en-GB.json";
import MessageBox from "../../components/messageBox/MessageBox";
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasError: false,
            errorInfo: "",
        };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    };
    ErrorBoundary.prototype.render = function () {
        return !this.state.hasError ? (this.props.children) : (_jsx(MessageBox, { status: translations.data["venonboard.process.failure"], statusType: "negative", primaryMessage: this.state.errorInfo }));
    };
    return ErrorBoundary;
}(React.Component));
export default ErrorBoundary;
